import { createContext, FC, ReactNode, useContext } from "react";

import type { PaymentChoice } from "../PaymentCards/PaymentCards";

export interface ChoosePaymentContextValue {
  choosePayment: (choice: PaymentChoice) => void;
}

const ChoosePaymentContext = createContext<ChoosePaymentContextValue | null>(null);

interface ChoosePaymentProviderProps {
  value: ChoosePaymentContextValue;
  children: ReactNode;
}

export const ChoosePaymentProvider: FC<ChoosePaymentProviderProps> = ({ value, children }) => (
  <ChoosePaymentContext.Provider value={value}>{children}</ChoosePaymentContext.Provider>
);

export const useChoosePaymentContext = () => useContext(ChoosePaymentContext);
